module.exports = __webpack_public_path__ + "img/2.4_Students-Trainees_2_James@2x.63b98e9ae98714970efdf0d56839be36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.4_Students-Trainees_2_James@2x.png
// module id = 765
// module chunks = 0